import { Propagation } from "@opendaw/lib-box";
import { Devices } from "../DeviceAdapter";
import { IconSymbol } from "../IconSymbol";
export class AudioBusBoxAdapter {
    type = "bus";
    accepts = "audio";
    #context;
    #box;
    constructor(context, box) {
        this.#context = context;
        this.#box = box;
    }
    catchupAndSubscribe(observer) {
        observer(this);
        return this.#box.subscribe(Propagation.Children, () => observer(this));
    }
    get uuid() { return this.#box.address.uuid; }
    get address() { return this.#box.address; }
    get box() { return this.#box; }
    get enabledField() { return this.#box.enabled; }
    get minimizedField() { return this.#box.minimized; }
    get iconField() { return this.#box.icon; }
    get labelField() { return this.#box.label; }
    get colorField() { return this.#box.color; }
    get iconSymbol() { return IconSymbol.fromName(this.iconField.getValue() ?? "audio-bus"); }
    deviceHost() {
        return this.#context.boxAdapters
            .adapterFor(this.#box.output.targetVertex.unwrap("No AudioUnitBox found").box, Devices.isHost);
    }
    audioUnitBoxAdapter() { return this.deviceHost().audioUnitBoxAdapter(); }
    terminate() { }
    toString() { return `{${this.constructor.name}}`; }
}
